import { WonLossStatus } from '@snap-types/models/enums';

// NOTE - See parallel definition for SnapQuote at snap-types/src/models/snap-quote/enums.ts
// NOTE 2: WonLossStatus has User Defined Field ID 00091
export const WON_LOSS_STATUS_MAPPING = {
  [WonLossStatus.QUOTED]: 'Quoted',
  [WonLossStatus.PAUSED]: 'Paused',
  [WonLossStatus.RFQ_RECEIVED]: 'RFQ Received',
  [WonLossStatus.CONVERTED]: 'Converted',
  [WonLossStatus.LOSS_PRICE]: 'Loss: Price',
  [WonLossStatus.COMPLETED]: 'Completed',
  [WonLossStatus.PENDING_BUYOUT_PRICE]: 'Pending Buyout Price',
  [WonLossStatus.PENDING_REVISED_PO_CONTRACT_REVIEW]:
    'Pending Revised PO (Contract Review)',
  [WonLossStatus.PENDING_CUSTOMER_RESPONSE]: 'Pending Customer Response',
  [WonLossStatus.LOSS_CAPABILITIES]: 'Loss: Capabilities',
  [WonLossStatus.PENDING_OUTSIDE_PROCESS]:
    'Pending Outside Process and/or raw material (Price/Lead Time)',
  [WonLossStatus.PENDING_MANUFACTURING]: 'Pending Manufacturing',
  [WonLossStatus.LOSS_ROUTINE_COMPETITIVE_CHECK]:
    'Loss: Routine Competative Check',
  [WonLossStatus.PENDING_REVISED_PO_PRICE]:
    'Pending Revised PO (Price/Lead Time)',
  [WonLossStatus.LOSS_CUSTOMER_LOST_BID]: 'Loss: Customer lost bid',
  [WonLossStatus.LOSS_CAPABILITIES_NO_QUOTE]: 'Loss: Capabilities/No Quote',
  [WonLossStatus.LOSS_QUOTE_NOT_FAST_ENOUGH]: 'Loss: Quote not fast enough',
  [WonLossStatus.LOSS_PROJECT_CANCELLED]: 'Loss: Project Cancelled',
  [WonLossStatus.LOSS_QUOTING_FOR_MULTIPLE_CUSTOMERS]:
    'Loss: Quoting for multiple customers',
  [WonLossStatus.LOSS_LEAD_TIME]: 'Loss: Lead Time',
  [WonLossStatus.LOSS_QUOTING_FOR_MULTIPLE_REVS_PART_ITERATIONS]:
    'Loss: Quoting for multiple revs/part iterations',
  [WonLossStatus.LOSS_EXCEPTIONS_NOT_ACCEPTED]: 'Loss: Exceptions not accepted',
  [WonLossStatus.LOSS_TERMS_OF_SALE]: 'Loss: Terms of Sale',
  [WonLossStatus.LOSS_LACKING_CERTIFICATION]: 'Loss: Lacking Certification',
  [WonLossStatus.WIN_LEAD_TIME]: 'Win: Lead Time',
  [WonLossStatus.WIN_CAPABILITIES]: 'Win: Capabilities',
  [WonLossStatus.WIN_PRICE]: 'Win: Price',
} as const satisfies Record<WonLossStatus, string>;

export function formatWonLossStatus(status: unknown): string {
  return WON_LOSS_STATUS_MAPPING[status as WonLossStatus] ?? status;
}

export const WON_LOSS_STATUS_OPTIONS = Object.entries(WonLossStatus).map(
  ([key, value]) => ({
    label: formatWonLossStatus(value),
    value: key,
  }),
);
